<div *ngFor="let cell of recordCells" class="flex-column align-items-start">
    <div>{{cell.fieldName}}</div>
    <div>{{cell.value}}</div>
</div>
